window._ = require('lodash');
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');
window.$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': window.$('meta[name="csrf-token"]').attr('content')
    },
    cache: false,
    dataType: 'json',
    timeout: 30000
});

require('jquery-ui');
require('../../../node_modules/jquery-ui/ui/widgets/draggable');
require('../../../node_modules/jquery-ui/ui/widgets/droppable');
require('../../../node_modules/jquery-ui/ui/widgets/datepicker');
require('jquery.actual');
require('./jquery.loading-indicator/jquery.loading-indicator.min');
require('jquery-toast-plugin');
require('icheck');

window.Popper = require('popper.js').default;
require('bootstrap');

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue').default || require('vue');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest'
};
if(process.env.NODE_ENV === 'development')
    window.axios.defaults.baseURL = 'http://localhost/dengueFever/public/';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if(token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from "laravel-echo"

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });

require('admin-lte');



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js